import { PLATFORM_TAB_GROUP_ID, PLATFORM_TABS } from './Platform/PlatformTabs';
import { COMPANY_PAGE_TAB_GROUP_ID, COMPANY_PAGE_TABS } from './CompanyPage/CompanyPageTabs';
import { NEW_HIRE_EXPERIENCE_TAB_GROUP_ID, NEW_HIRE_EXPERIENCE_TABS } from './NewHireExperience/NewHireExperienceTabs';
import { addTabGroupTranslatedLabel } from './platformSettingsTabUtils';

export const PLATFORM_SETTINGS_TABS = [...PLATFORM_TABS, ...COMPANY_PAGE_TABS, ...NEW_HIRE_EXPERIENCE_TABS];

export const PLATFORM_SETTINGS_TAB_GROUPS = [
  PLATFORM_TAB_GROUP_ID,
  COMPANY_PAGE_TAB_GROUP_ID,
  NEW_HIRE_EXPERIENCE_TAB_GROUP_ID,
].map(addTabGroupTranslatedLabel);
